 <form name="formEntityType" [formGroup]="formEntityType" class="accounts-receivable-edit w-100-p"
                        autocomplete="off">
<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="5px" fxLayoutGap.lt-md="0px">
    <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>Tipo</mat-label>
        <mat-select matInput [formControl]="typeDebtorControl" [compareWith]="compareSelect">
            <mat-option>Selecione</mat-option>
            <mat-option *ngFor="let typeDebtor of typeDebtorList" [value]="typeDebtor">
                <p>{{typeDebtor.name}}</p>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'C'">
        <mat-label>Convênio</mat-label>
        <input placeholder="Convênio" type="search" id="financial-bonds-accounts_receivable-insurance-edit-form_ac"
            formControlName="insurance" matInput [matAutocomplete]="autoInsurance" />
        <mat-error *ngIf="formEntityType.get('insurance').hasError('incorrect')">
            Convênio inválido
        </mat-error>
        <mat-autocomplete #autoInsurance="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let insurance of insuranceList" [value]="insurance">
                {{ insurance.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'O'">
        <mat-label>Fornecedor</mat-label>
        <input placeholder="Fornecedor" type="search" id="financial-bonds-accounts_receivable-supplier-edit-form_ac"
            formControlName="supplier" matInput [matAutocomplete]="autoSupplier" />
        <mat-error *ngIf="formEntityType.get('supplier').hasError('incorrect')
                                                                        ">
            Fornecedor inválido
        </mat-error>
        <mat-error *ngIf="formEntityType.get('supplier').hasError('required')">
            Campo obrigatório
        </mat-error>
        <mat-autocomplete #autoSupplier="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let supplier of supplierList" [value]="supplier">
                {{ supplier.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'P'">
        <mat-label>Paciente</mat-label>
        <input placeholder="Paciente" type="search" id="financial-bonds-accounts_receivable-patient-edit-form_ac"
            formControlName="patient" matInput [matAutocomplete]="autoPatient" />
        <mat-error *ngIf="formEntityType.get('patient').hasError('incorrect')">
            Paciente não selecionado
        </mat-error>
        <mat-autocomplete #autoPatient="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let patient of patientList" [value]="patient">
                {{ patient.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'S'">
        <mat-label>Pessoa Física</mat-label>
        <input placeholder="Pessoa Física" type="search" id="financial-bonds-accounts_receivable-person-edit-form_ac"
            formControlName="person" matInput [matAutocomplete]="autoPerson" />
        <mat-error *ngIf="formEntityType.get('person').hasError('incorrect')">
            Pessoa não selecionado
        </mat-error>
        <mat-autocomplete #autoPerson="matAutocomplete" [displayWith]="displayFnPatientPlan">
            <mat-option *ngFor="let person of personList" [value]="person">
                {{ person.patientName }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'X'">
        <mat-label>Profissional</mat-label>
        <input placeholder="Profissional" type="search" id="financial-bonds-accounts_receivable-performer-edit-form_ac"
            formControlName="performer" matInput [matAutocomplete]="autoPerformer" />
        <mat-error *ngIf="formEntityType.get('performer').hasError('incorrect')">
            Profissional não selecionado
        </mat-error>
        <mat-autocomplete #autoPerformer="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let performer of performerList" [value]="performer">
                {{ performer.performerName }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'R'">
        <mat-label>Profissional</mat-label>
        <input placeholder="Profissional" type="search"
            id="financial-bonds-accounts_receivable-professional-edit-form_ac" formControlName="professional" matInput
            [matAutocomplete]="autoProfessional" autocomplete="off" />

      

        <mat-error *ngIf="formEntityType.get('professional').hasError('incorrect')">
            Profissional não selecionado
        </mat-error>
        <mat-autocomplete #autoProfessional="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let professional of professionalList" [value]="professional">
                {{ professional.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'U'">
        <mat-label>Usuário</mat-label>
        <input placeholder="Usuário" type="search" id="financial-bonds-accounts_receivable-user-edit-form_ac"
            formControlName="user" matInput [matAutocomplete]="autoProfessional" />
        <mat-error *ngIf="formEntityType.get('user').hasError('incorrect')">
            Usuário não selecionado
        </mat-error>
        <mat-autocomplete #autoProfessional="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let user of userList" [value]="user">
                {{ user.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>



    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'E'">
        <mat-label>Empresa</mat-label>
        <input placeholder="Empresa" type="search" id="financial-bonds-accounts_receivable-company_target-edit-form_ac"
            formControlName="companyTarget" matInput [matAutocomplete]="autoCompanyTarget" />
        <mat-error *ngIf="formEntityType.get('companyTarget').hasError('incorrect')">
            Empresa não selecionado
        </mat-error>
        <mat-error *ngIf="formEntityType.get('companyTarget').hasError('required')">
            Campo obrigatório
        </mat-error>
        <mat-autocomplete #autoCompanyTarget="matAutocomplete" [displayWith]="displayFnCompany">
            <mat-option *ngFor="let companyTarget of companyTargetList" [value]="companyTarget">
                {{ companyTarget.alias }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="" fxFlex.lt-md="100" *ngIf="typeDebtorControl.value?.id == 'F'">
        <mat-label>Firma</mat-label>
        <input placeholder="Empresa" type="search" id="financial-bonds-accounts_receivable-firm-edit-form_ac"
            formControlName="firm" matInput [matAutocomplete]="autoFirm" />

        <mat-error *ngIf="formEntityType.get('firm').hasError('incorrect')">
            Firma não selecionado
        </mat-error>
        <mat-autocomplete #autoFirm="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let firm of firmList" [value]="firm">
                {{ firm.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>


</div>